import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Panel } from 'primereact/panel';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import moment from 'moment-timezone';
import Paginator from '../../components/Paginator';
import DataTableHeader, { Employee, NonEmployee } from './DataTableHeader';
import { parse, sortUrl, toSortOrder } from '../../utils/UrlUtil';
import { intlShape } from '../../components/prop-types';
import { RespondentType } from '../../shared/Constants';

const messages = defineMessages({
  name: { id: 'attrs.name', defaultMessage: 'Name' },
  email: { id: 'attrs.email', defaultMessage: 'Email' },
  updated: { id: 'attrs.updated', defaultMessage: 'Updated' },
});

const RespondentTypeHeader = () => (
  <React.Fragment>
    <Employee />
    /
    <NonEmployee />
  </React.Fragment>
);

function updatedTemplate(rowData, column) {
  const updated = column.formatDate(moment(rowData.updatedOn), {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  });
  return updated;
}

function typeTemplate(rowData) {
  if (rowData.type === RespondentType.INTERNAL) {
    return <Employee />;
  }

  return <NonEmployee />;
}

function nameTemplate(rowData, column) {
  return (
    <Link to={`/accounts/${column.currentAccount}/respondents/${rowData.id}`} className="app-link">
      {rowData.name}
    </Link>
  );
}

class Respondents extends Component {
  constructor(props) {
    super(props);
    this.onSortChange = this.onSortChange.bind(this);
  }

  onSortChange(event) {
    const { location, history } = this.props;
    sortUrl(event, location, history);
  }

  render() {
    const {
      respondents,
      intl: { formatMessage, formatDate },
      currentAccount,
      location,
      loading,
    } = this.props;

    const { edges, totalCount, indexFrom, indexTo, pageInfo } = respondents;

    const respondentsRows = edges.map(({ node }) => ({
      ...node,
      name: `${node.firstName} ${node.lastName}`,
    }));

    const params = parse(location.search);
    const { sort = {} } = params;
    const { sortBy, sortDir } = sort;

    const nameHeader = formatMessage(messages.name);
    const emailHeader = formatMessage(messages.email);
    const updatedHeader = formatMessage(messages.updated);

    const footer = <Paginator totalCount={totalCount} indexFrom={indexFrom} indexTo={indexTo} pageInfo={pageInfo} />;

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <Panel>
              <div className="p-grid">
                <div className="p-col-12 align-center">
                  <DataTableHeader />
                  <DataTable
                    value={respondentsRows}
                    responsive
                    sortField={sortBy}
                    sortOrder={toSortOrder(sortDir)}
                    onSort={this.onSortChange}
                    lazy
                    loading={loading}
                    autoLayout
                  >
                    <Column
                      field="type"
                      header={<RespondentTypeHeader />}
                      body={typeTemplate}
                      style={{ width: '64px' }}
                    />
                    <Column
                      field="name"
                      sortField="firstName"
                      header={nameHeader}
                      body={nameTemplate}
                      currentAccount={currentAccount}
                      sortable
                      style={{ textAlign: 'left' }}
                    />
                    <Column field="email" header={emailHeader} sortable />
                    <Column
                      field="updatedOn"
                      header={updatedHeader}
                      sortable
                      body={updatedTemplate}
                      formatDate={formatDate}
                    />
                  </DataTable>
                </div>
                <div className="p-col-12 align-center">{footer}</div>
              </div>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

Respondents.propTypes = {
  respondents: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: intlShape.isRequired,
  currentAccount: PropTypes.string.isRequired,
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  loading: PropTypes.bool.isRequired,
};

export default withRouter(injectIntl(Respondents));
